<template>
    <div>
        <div class="app-page-title">
            <div class="page-title-wrapper">
                <div class="page-title-heading">
                    <div class="page-title-icon">
                        <i :class="icon"/>
                    </div>
                    <div>
                        {{heading}}
                        <div
                                class="page-title-subheading">
                            {{subheading}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content">
            <div class="main-card mb-3 card">
                <div class="card-body"><h5 class="card-title">Remplir les informations client</h5>
                    <form class="" @submit.prevent="saveClient">
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="position-relative form-group">
                                    <label for="number" class="">N°</label>
                                    <input name="email" id="number"
                                           placeholder="N°"
                                           type="text"
                                           required
                                           v-model="client.number"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="first_ame" class="">Nom</label>
                                    <input name="email" id="first_ame"
                                           placeholder="Nom"
                                           type="text"
                                           required
                                           v-model="client.first_name"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="last_name" class="">Prenom</label>
                                    <input name="email" id="last_name"
                                           placeholder="Prenom"
                                           type="text"
                                           required
                                           v-model="client.last_name"
                                           class="form-control">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="email" class="">Email</label>
                                    <input name="email" id="email"
                                           placeholder="Email"
                                           type="email"
                                           v-model="client.email"
                                           class="form-control">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="phone" class="">Tel</label>
                                    <input name="phone"
                                           id="phone"
                                           placeholder="0660 77 55 99"
                                           type="text"
                                           v-mask="['#### ## ## ##', '### ## ## ##']"
                                           v-model="client.phone"
                                           class="form-control">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="birthday" class="">Date de naissance</label>
                                    <datepicker :language="fr"
                                                id="birthday"
                                                inputClass="form-control bg-white"
                                                required
                                                placeholder="Date de naissance"
                                                format="dd/MM/yyyy"
                                                v-mask="'##/##/####'"
                                                :typeable="false"
                                                :value="new Date(client.birthday)"
                                                v-model="client.birthday"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="sampleDate" class="">Date de prélèvement</label>
                                    <datepicker :language="fr"
                                                id="sampleDate"
                                                inputClass="form-control bg-white"
                                                placeholder="Date de naissance"
                                                format="dd/MM/yyyy"
                                                v-mask="'##/##/####'"
                                                :typeable="false"
                                                :value="new Date(client.sampleDate)"
                                                v-model="client.sampleDate"/>
                                </div>
                            </div>
                        </div>
                        <div class="position-relative form-group">
                            <label for="address" class="">Address</label>
                            <input name="address"
                                   id="address"
                                   v-model="client.address"
                                   placeholder="1234 Main St"
                                   type="text"
                                   class="form-control">
                        </div>
                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="state" class="">Wilaya</label>
                                    <input name="state" id="state"
                                           type="text"
                                           v-model="client.state"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="position-relative form-group">
                                    <label for="city" class="">Ville</label>
                                    <input name="city" id="city"
                                           type="text"
                                           v-model="client.city"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="position-relative form-group">
                                    <label for="zip" class="">Code Postal</label>
                                    <input name="zip"
                                           id="zip"
                                           type="text"
                                           v-model="client.zip"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="blood-type" class="">groupe</label>
                                    <select type="select" id="blood-type"
                                            class="custom-select"
                                            required
                                            v-model="client.type">
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="AB">AB</option>
                                        <option value="O">O</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="position-relative form-group">
                                    <label for="r" class="">Rhésus</label>
                                    <select type="select" id="r"
                                            class="custom-select"
                                            required
                                            v-model="client.r">
                                        <option value="+">Positive ( + )</option>
                                        <option value="-">Negative ( - )</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <button class="mt-2 btn btn-primary" type="submit">Enregistrer</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker-sm'
import fr from 'vuejs-datepicker-sm/dist/locale/translations/fr'
import { mask } from 'vue-the-mask'
import uniqid from 'uniqid'

export default {
  name: 'ClientEdit',
  components: {
    Datepicker
  },
  directives: { mask },
  data: () => ({
    fr,
    heading: 'Ajouter client',
    subheading: 'Remplir les informations client',
    icon: 'pe-7s-user text-success',
    client: {
      id: uniqid(),
      first_name: '',
      last_name: '',
      birthday: '01/01/1990',
      sampleDate: new Date(),
      number: '',
      address: '',
      state: '',
      city: '',
      zip: '',
      type: 'A',
      r : '+'
    }
  }),
  props: {
    id: String
  },
  methods: {
    saveClient() {
      this.$store.dispatch('SetClient', {...this.client})
        .then(() => {
          this.$router.push({name: 'client', params: {id: this.client.id}})
        })
    }
  },

}
</script>
